import { Content, ContentTable, Margins } from "pdfmake/interfaces";

/** @deprecated Use spacing on functional blocks instead. */
export const br = (numberOfLines = 1): Content => ({ text: "\n".repeat(numberOfLines - 1) });

export const section = (data: { title: string; content: Content }): Content[] => [
	{ text: data.title, fontSize: 14, bold: true },
	data.content,
];

export const unbreakableSection = (data: { title: string; content: Content }) => {
	return {
		stack: section(data),
		unbreakable: true,
	};
};

export const card = (data: { content: Content; options?: { margins: Margins } }): ContentTable => ({
	table: { widths: ["*"], body: [[data.content]] },
	layout: {
		hLineColor: "lightgray",
		vLineColor: "lightgray",
		paddingTop: () => 10,
		paddingLeft: () => 8,
		paddingRight: () => 8,
	},
	margin: data.options?.margins ?? [0, 12],
});

export const descriptionItem = (data: { term: string; content: Content }): Content[] => [
	{ text: data.term, color: "gray" },
	data.content,
];

export const divider = (): ContentTable => ({
	table: { widths: ["*"], body: [[{ text: "", lineHeight: 0 }], [{ text: "", lineHeight: 0 }]] },
	layout: {
		hLineWidth: (i) => (i === 1 ? 1 : 0),
		hLineColor: "lightgray",
		vLineWidth: () => 0,
		paddingBottom: (i) => (i === 0 ? 4 : 0),
		paddingTop: (i) => (i === 1 ? 10 : 0),
		paddingLeft: () => 0,
		paddingRight: () => 0,
	},
});
